import { render, staticRenderFns } from "./RecordEnteringStatusNotification.vue?vue&type=template&id=a5b36324&scoped=true&"
import script from "./RecordEnteringStatusNotification.vue?vue&type=script&lang=js&"
export * from "./RecordEnteringStatusNotification.vue?vue&type=script&lang=js&"
import style0 from "./RecordEnteringStatusNotification.vue?vue&type=style&index=0&id=a5b36324&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b36324",
  null
  
)

export default component.exports